import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";
import ReportHistoryRow from "./ReportHistoryRow.vue";
import { IReportHistory } from "@/domain/entities/report";
import EmptyContent from "../shared/EmptyContent.vue";


const __default__ = {
  name: "ReportHistoryList",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  reportHistories: {
    type: Array as PropType<IReportHistory[]>,
    default: () => [],
  },
},
  setup(__props, { expose: __expose }) {
  __expose();



const __returned__ = { ReportHistoryRow, EmptyContent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})